import React, { useContext } from "react";
import { useState, useEffect } from "react";
import "../../Tabels/Tabels.css";
import { Link } from "react-router-dom";
import { Context } from "../../../utils/context";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fas } from "@fortawesome/free-solid-svg-icons";
// *******************toster****************************
import Select from "react-select";
import ModalSave from "../../common/ModelSave";
import Validation from "../../common/FormValidation";
import { CancelButton, SaveButton } from "../../common/Button";

import { Row, Col, Form, InputGroup, Modal } from "react-bootstrap";
import { useForm, Controller } from "react-hook-form";
import classNames from "classnames";
import JoditEditor from "jodit-react";
library.add(fas);

const EditDriverDocument = (props) => {
  const id = props.show;
  const { postData, putData, getData, Select2Data, getDimension, IMG_URL } =
    useContext(Context);
  const [countries, setCountries] = useState([]);
  const [showModal, setShowModal] = useState({
    code: 0,
    message: "",
  });

  const GetEditData = async () => {
    const response = await getData(`/employee/driver/${id}`);
    const data = {
      driving_license_front:
        response?.data?.driver_document?.driving_license_front,
      driving_license_back:
        response?.data?.driver_document?.driving_license_back,
      aadhar_card_back: response?.data?.driver_document?.aadhar_card_back,
      aadhar_card_front: response?.data?.driver_document?.aadhar_card_front,
      profile_photo: response?.data?.profile_photo,
    };
    reset(data);
  };

  useEffect(() => {
    // GetAllCategory();
    GetEditData();
  }, []);

  const {
    control,
    register,
    handleSubmit,
    formState: { errors },
    reset,
    trigger,
    setValue,
    watch,
    getValues,
  } = useForm();
  const imageFileProfilePhoto = watch("profile_photo");
  const imageFileAadharCardFront = watch("aadhar_card_front");
  const imageFileAadharCardBack = watch("aadhar_card_back");
  const imageFileDrivingLicenseBack = watch("driving_license_back");
  const imageFileDrivingLicenseFront = watch("driving_license_front");
  const onSubmit = async (data) => {
    try {
      const DataToSend = new FormData();
      DataToSend.append("aadhar_card_front", data?.aadhar_card_front[0]);
      DataToSend.append("profile_photo", data?.profile_photo[0]);
      DataToSend.append("aadhar_card_back", data?.aadhar_card_back[0]);
      DataToSend.append("driving_license_back", data?.driving_license_back[0]);
      DataToSend.append(
        "driving_license_front",
        data?.driving_license_front[0],
      );
      const response = await putData(
        `/employee/customers/driver-document/${id}`,
        DataToSend,
      );

      if (response?.success) {
        await setShowModal({ code: response.code, message: response.message });
      } else {
        await setShowModal({ code: response.code, message: response.message });
      }
      setTimeout(() => {
        setShowModal(0);
        props.handleClose();
      }, 1000);
    } catch (error) {
      console.log(error);
    }
  };

  return (
    <>
      <Modal
        {...props}
        onHide={props.handleClose}
        size="lg"
        aria-labelledby="contained-modal-title-vcenter"
        centered
        className="edit-modal-holder"
      >
        <Modal.Header closeButton>
          <Modal.Title id="contained-modal-title-vcenter">
            Edit Driver Document
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <Form onSubmit={() => handleSubmit(onSubmit)} role="form">
            <Row>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label> Profile Photo </Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.profile_photo,
                        })}
                        type="file"
                        {...register("profile_photo", {
                          validate: async (value) => {
                            if (
                              (!value || value.length === 0) &&
                              typeof value !== "string"
                            ) {
                              return "Profile photo is required";
                            }

                            // ✅ Existing image (edit case)
                            if (typeof value === "string") {
                              return true;
                            }
                            if (typeof value !== "string") {
                              const fileTypes = ["jpg", "png", "jpeg"];
                              const fileType = value[0].name?.split(".")[1];

                              if (!fileTypes.includes(fileType)) {
                                return `please upload a valid file format. (${fileTypes})`;
                              }

                              // const sizes = await getDimension(value[0]);
                              // if (sizes.width !== 352 && sizes.height !== 236) {
                              //   return "Image width and height must be 352 px and 236 px";
                              // }

                              // const fileSize = Math.round(
                              //   value[0].size / 1024
                              // );
                              // if (fileSize > 500) {
                              //   return "file size must be lower than 500kb";
                              // }
                            }
                          },
                        })}
                        accept=".jpg, .jpeg, .png"
                        multiple={false}
                      />
                    </Form.Group>
                    {errors.profile_photo && (
                      <span className="text-danger">
                        {errors.profile_photo.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Image Preview </Form.Label>

                    {typeof getValues("profile_photo") == "string" ? (
                      <div className="image-preview-container mt-3">
                        <img
                          src={IMG_URL + getValues("profile_photo")}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    ) : (
                      imageFileProfilePhoto &&
                      imageFileProfilePhoto?.length > 0 && (
                        <div className="image-preview-container mt-3">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(imageFileProfilePhoto[0])}
                            alt="Preview"
                            className="image-preview"
                          />
                        </div>
                      )
                    )}
                  </Row>
                </div>
              </Col>
              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label> Aadhar Front </Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.aadhar_card_front,
                        })}
                        type="file"
                        {...register("aadhar_card_front", {
                          // required: "aadhar_card_front is required",
                          validate: async (value) => {
                            if (
                              (!value || value.length === 0) &&
                              typeof value !== "string"
                            ) {
                              return "Aadhar Front is required";
                            }

                            if (typeof value === "string") {
                              return true;
                            }
                            if (typeof value !== "string") {
                              const fileTypes = ["jpg", "png", "jpeg"];
                              const fileType = value[0].name?.split(".")[1];

                              if (!fileTypes.includes(fileType)) {
                                return `please upload a valid file format. (${fileTypes})`;
                              }

                              // const sizes = await getDimension(value[0]);
                              // if (sizes.width !== 352 && sizes.height !== 236) {
                              //   return "Image width and height must be 352 px and 236 px";
                              // }

                              // const fileSize = Math.round(
                              //   value[0].size / 1024
                              // );
                              // if (fileSize > 500) {
                              //   return "file size must be lower than 500kb";
                              // }
                            }
                          },
                        })}
                        accept=".jpg, .jpeg, .png"
                        multiple={false}
                      />
                    </Form.Group>
                    {errors.aadhar_card_front && (
                      <span className="text-danger">
                        {errors.aadhar_card_front.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Image Preview </Form.Label>

                    {typeof getValues("aadhar_card_front") === "string" ? (
                      <div className="image-preview-container mt-3">
                        <img
                          src={IMG_URL + getValues("aadhar_card_front")}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    ) : (
                      imageFileAadharCardFront &&
                      imageFileAadharCardFront?.length > 0 && (
                        <div className="image-preview-container mt-3">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(
                              imageFileAadharCardFront[0],
                            )}
                            alt="Preview"
                            className="image-preview"
                          />
                        </div>
                      )
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label> Aadhar Back </Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.aadhar_card_back,
                        })}
                        type="file"
                        {...register("aadhar_card_back", {
                          // required: "aadhar_card_back is required",
                          validate: async (value) => {
                            if (
                              (!value || value.length === 0) &&
                              typeof value !== "string"
                            ) {
                              return "Aadhar Back is required";
                            }

                            // ✅ Existing image (edit case)
                            if (typeof value === "string") {
                              return true;
                            }
                            if (typeof value !== "string") {
                              const fileTypes = ["jpg", "png", "jpeg"];
                              const fileType = value[0].name?.split(".")[1];

                              if (!fileTypes.includes(fileType)) {
                                return `please upload a valid file format. (${fileTypes})`;
                              }

                              // const sizes = await getDimension(value[0]);
                              // if (sizes.width !== 352 && sizes.height !== 236) {
                              //   return "Image width and height must be 352 px and 236 px";
                              // }

                              // const fileSize = Math.round(
                              //   value[0].size / 1024
                              // );
                              // if (fileSize > 500) {
                              //   return "file size must be lower than 500kb";
                              // }
                            }
                          },
                        })}
                        accept=".jpg, .jpeg, .png"
                        multiple={false}
                      />
                    </Form.Group>
                    {errors.aadhar_card_back && (
                      <span className="text-danger">
                        {errors.aadhar_card_back.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Image Preview</Form.Label>

                    {/* Existing image (edit mode) */}
                    {typeof getValues("aadhar_card_back") === "string" ? (
                      <div className="image-preview-container mt-3">
                        <img
                          src={IMG_URL + getValues("aadhar_card_back")}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    ) : (                  
                      imageFileAadharCardBack &&
                      imageFileAadharCardBack.length > 0 &&
                      imageFileAadharCardBack[0] instanceof File && (
                        <div className="image-preview-container mt-3">
                          <img
                            src={URL.createObjectURL(
                              imageFileAadharCardBack[0],
                            )}
                            alt="Preview"
                            className="image-preview"
                          />
                        </div>
                      )
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label> Driving License Front </Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.driving_license_front,
                        })}
                        type="file"
                        {...register("driving_license_front", {
                          // required: "driving_license_front is required",
                          validate: async (value) => {
                            if (
                              (!value || value.length === 0) &&
                              typeof value !== "string"
                            ) {
                              return "Driving License Front is required";
                            }

                            // ✅ Existing image (edit case)
                            if (typeof value === "string") {
                              return true;
                            }
                            if (typeof value !== "string") {
                              const fileTypes = ["jpg", "png", "jpeg"];
                              const fileType = value[0].name?.split(".")[1];

                              if (!fileTypes.includes(fileType)) {
                                return `please upload a valid file format. (${fileTypes})`;
                              }

                              // const sizes = await getDimension(value[0]);
                              // if (sizes.width !== 352 && sizes.height !== 236) {
                              //   return "Image width and height must be 352 px and 236 px";
                              // }

                              // const fileSize = Math.round(
                              //   value[0].size / 1024
                              // );
                              // if (fileSize > 500) {
                              //   return "file size must be lower than 500kb";
                              // }
                            }
                          },
                        })}
                        accept=".jpg, .jpeg, .png"
                        multiple={false}
                      />
                    </Form.Group>
                    {errors.driving_license_front && (
                      <span className="text-danger">
                        {errors.driving_license_front.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Image Preview </Form.Label>

                    {typeof getValues("driving_license_front") === "string" ? (
                      <div className="image-preview-container mt-3">
                        <img
                          src={IMG_URL + getValues("driving_license_front")}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    ) : (
                      imageFileDrivingLicenseFront &&
                      imageFileDrivingLicenseFront?.length > 0 && (
                        <div className="image-preview-container mt-3">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(
                              imageFileDrivingLicenseFront[0],
                            )}
                            alt="Preview"
                            className="image-preview"
                          />
                        </div>
                      )
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label> Driving License Back </Form.Label>

                    <Form.Group>
                      <Form.Control
                        className={classNames("", {
                          "is-invalid": errors?.driving_license_back,
                        })}
                        type="file"
                        {...register("driving_license_back", {
                          // required: "driving_license_back is required",
                          validate: async (value) => {
                            if (
                              (!value || value.length === 0) &&
                              typeof value !== "string"
                            ) {
                              return "Driving License Back is required";
                            }

                            // ✅ Existing image (edit case)
                            if (typeof value === "string") {
                              return true;
                            }
                            if (typeof value !== "string") {
                              const fileTypes = ["jpg", "png", "jpeg"];
                              const fileType = value[0].name?.split(".")[1];

                              if (!fileTypes.includes(fileType)) {
                                return `please upload a valid file format. (${fileTypes})`;
                              }

                              // const sizes = await getDimension(value[0]);
                              // if (sizes.width !== 352 && sizes.height !== 236) {
                              //   return "Image width and height must be 352 px and 236 px";
                              // }

                              // const fileSize = Math.round(
                              //   value[0].size / 1024
                              // );
                              // if (fileSize > 500) {
                              //   return "file size must be lower than 500kb";
                              // }
                            }
                          },
                        })}
                        accept=".jpg, .jpeg, .png"
                        multiple={false}
                      />
                    </Form.Group>
                    {errors.driving_license_back && (
                      <span className="text-danger">
                        {errors.driving_license_back.message}
                      </span>
                    )}
                  </Row>
                </div>
              </Col>

              <Col lg={6}>
                <div className="main-form-section mt-3">
                  <Row className="justify-content-center">
                    <Form.Label>Image Preview </Form.Label>

                    {typeof getValues("driving_license_back") == "string" ? (
                      <div className="image-preview-container mt-3">
                        <img
                          src={IMG_URL + getValues("driving_license_back")}
                          alt="Preview"
                          className="image-preview"
                        />
                      </div>
                    ) : (
                      imageFileDrivingLicenseBack &&
                      imageFileDrivingLicenseBack?.length > 0 && (
                        <div className="image-preview-container mt-3">
                          <img
                            // src={URL.createObjectURL(getValues("image")[0])}
                            src={URL?.createObjectURL(
                              imageFileDrivingLicenseBack[0],
                            )}
                            alt="Preview"
                            className="image-preview"
                          />
                        </div>
                      )
                    )}
                  </Row>
                </div>
              </Col>

              <Row className="mt-5 pb-3">
                <div className="d-flex justify-content-center">
                  <Link>
                    <CancelButton
                      name={"cancel"}
                      handleClose={props.handleClose}
                    />
                  </Link>

                  <SaveButton
                    name={"save"}
                    handleSubmit={handleSubmit(onSubmit)}
                  />
                </div>
              </Row>
            </Row>
          </Form>
        </Modal.Body>
      </Modal>

      <ModalSave
        message={showModal.message}
        showErrorModal={showModal.code ? true : false}
      />
    </>
  );
};

export default EditDriverDocument;
